module.exports = __webpack_public_path__ + "img/1.66aedd61.jpg";